import React from 'react';

import Card from '../../../../components/Card';
import ReadmoreLabel from '../../../../components/ReadmoreLabel';

import './style.scss';

interface NodeEquipmentCardProps {
  title: string;
  subtitle?: string;
  image: React.ReactNode;
  link: string;
}

const NodeEquipmentCard: React.FC<NodeEquipmentCardProps> = ({
  title,
  subtitle,
  image,
  link,
}) => (
  <Card className="NodeEquipmentCard">
    <Card.Content>
      <Card.Image
        image={image}
      />

      <div className="Card__content__text">
        <Card.Link href={link}>
          <Card.Title title={title} />
        </Card.Link>

        {subtitle && (
          <>
            <Card.Subtitle
              subtitle={(
                <p className="u-truncate--4">
                  {subtitle}
                </p>
              )}
            />
            <ReadmoreLabel />
          </>
        )}
      </div>

    </Card.Content>
  </Card>
);

export default NodeEquipmentCard;
